export default "/build/images/7.png?3e73fb8f7868ef54aa9b9d6668871ec4";